import { render, staticRenderFns } from "./LocalStock.vue?vue&type=template&id=583c399e&"
import script from "./LocalStock.vue?vue&type=script&lang=js&"
export * from "./LocalStock.vue?vue&type=script&lang=js&"
import style0 from "./LocalStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports